import React from 'react';
import { Home, Search, HelpCircle, Phone } from 'lucide-react';
export function MobileStickyBar() {
  const focusSearch = () => {
    const el = document.getElementById('mobile-search') as HTMLInputElement | null;
    if (el) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      el.focus();
    }
  };
  return <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-brand-border shadow-[0_-10px_20px_rgba(9,46,37,0.05)] z-50 pb-safe" data-id="element-586">
      <div className="flex justify-around items-center h-16" data-id="element-587">
        <a href="#shop-by-need" aria-label="Shop by need" className="flex flex-col items-center justify-center w-full h-full text-brand-charcoal hover:text-brand-maroon transition-colors active:bg-brand-panel" data-id="element-588">
          <Home size={22} className="mb-1" data-id="element-589" />
          <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-590">
            Shop
          </span>
        </a>
        <button type="button" onClick={focusSearch} aria-label="Search products" className="flex flex-col items-center justify-center w-full h-full text-brand-charcoal hover:text-brand-maroon transition-colors border-l border-brand-border/50 active:bg-brand-panel" data-id="element-591">
          <Search size={22} className="mb-1" data-id="element-592" />
          <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-593">
            Search
          </span>
        </button>
        <a href="/ContactUs.html" aria-label="Get help" className="flex flex-col items-center justify-center w-full h-full text-brand-charcoal hover:text-brand-maroon transition-colors border-l border-brand-border/50 active:bg-brand-panel" data-id="element-594">
          <HelpCircle size={22} className="mb-1" data-id="element-595" />
          <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-596">
            Help
          </span>
        </a>
        <a href="tel:301-620-7585" aria-label="Call 301-620-7585" className="flex flex-col items-center justify-center w-full h-full text-brand-maroon hover:text-brand-maroonDark transition-colors border-l border-brand-border/50 active:bg-brand-panel" data-id="element-597">
          <Phone size={22} className="mb-1" data-id="element-598" />
          <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-599">
            Call
          </span>
        </a>
      </div>
    </div>;
}